import { ENVIRONMENT_IDENTIFIER } from '@dealstack/frontend/shared/environment';
import {
	DEBUG_PARAMS,
	isDebugParamEnabled,
} from '@dealstack/frontend/shared/mechanism/debugging/util';
import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { EXACT_ENVIRONMENT, PROJECT } from '@dealstack/shared/lib/common/environment';
import { Helmet } from 'react-helmet';

const cookieScriptConfigMap = {
	[PROJECT.ADMIN]: {
		[EXACT_ENVIRONMENT.PRODUCTION]:
			'//cdn.cookie-script.com/s/8a668008d536c2f7683e71977ae22414.js',
	},
	[PROJECT.ADMIN_V2]: {
		[EXACT_ENVIRONMENT.PRODUCTION]:
			'//cdn.cookie-script.com/s/8a668008d536c2f7683e71977ae22414.js',
	},
	[PROJECT.INVESTOR]: {
		[EXACT_ENVIRONMENT.PRODUCTION]:
			'//cdn.cookie-script.com/s/2ec1d04dd694e3c71e0ff84de4845b91.js',
	},
	[PROJECT.GODMODE]: {
		[EXACT_ENVIRONMENT.PRODUCTION]: '',
	},
};

interface Props {
	project: PROJECT;
	environment: ENVIRONMENT_IDENTIFIER;
}

export const CookieScriptComponent = ({ project, environment }: Props) => {
	const [, match] = environment;
	const scriptUrl = cookieScriptConfigMap[project]?.[match];
	if (isDebugParamEnabled(DEBUG_PARAMS.DEBUG_COOKIE_SCRIPT)) {
		logger.debug(
			`CookieScriptComponent: project(${project}) environment(${environment}) scriptUrl(${scriptUrl})`
		);
	}
	if (!scriptUrl) {
		return <></>;
	}

	return (
		<Helmet>
			<script type="text/javascript" src={scriptUrl} />
		</Helmet>
	);
};
